export class NonOkResponseError extends Error {
    constructor(request: Request, response: Response) {
        const method = request.method.toUpperCase();
        const path = request.url.replace(new URL(request.url).origin, '');
        const message = `${method} ${path} responded with ${response.status} ${response.statusText}`;
        super(message);
    }
}
